module.exports = __webpack_public_path__ + "img/GAME_PAINTBALL2.d17a4b5f.jpg";